/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AnonymousServiceConfirmationEmailBinOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params {
  organizationFhirId: string;
  healthCareServiceFhirId: string;
  locationFhirId: string;
  specialityFhirId: string;
}

export function anonymousServiceConfirmationEmailBinOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(http: HttpClient, rootUrl: string, params: AnonymousServiceConfirmationEmailBinOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, anonymousServiceConfirmationEmailBinOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationFhirId', params.organizationFhirId, {});
    rb.path('healthCareServiceFhirId', params.healthCareServiceFhirId, {});
    rb.path('locationFhirId', params.locationFhirId, {});
    rb.path('specialityFhirId', params.specialityFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<string>>;
    })
  );
}

anonymousServiceConfirmationEmailBinOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH = '/Anonymous/ServiceConfirmationEmailBin/{organizationFhirId}/{healthCareServiceFhirId}/{locationFhirId}/{specialityFhirId}';
